module.exports = __webpack_public_path__ + "media/assets/icons/team-training-371f41086ff9e4bb41d282520f04bb6c.svg";